import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgVerifiedHome = (props) => (
  <SvgIcon {...props} title="VerifiedHome">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Verified-Home_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m10.383.028-.727.068c-2.18.202-4.544.777-6.379 1.552-.952.402-1.378.774-1.645 1.434l-.109.27v4.734c0 5.27-.007 5.117.332 6.492 1.03 4.172 3.846 7.277 8.097 8.927 1.763.684 2.333.684 4.096 0 4.25-1.65 7.068-4.755 8.097-8.927.34-1.374.332-1.221.332-6.492V3.352l-.11-.27c-.267-.662-.692-1.032-1.653-1.438C18.966.906 16.877.384 14.578.112c-.596-.07-3.687-.132-4.195-.084Zm3.492 1.57c2.743.233 6.55 1.288 6.976 1.933l.126.189v4.316c0 4.852 0 4.853-.352 6.24-.921 3.63-3.372 6.308-7.121 7.779-1.42.556-1.588.556-3.008 0-3.749-1.471-6.2-4.148-7.12-7.778-.352-1.388-.353-1.39-.353-6.241V3.72l.126-.19c.433-.654 4.321-1.722 7.046-1.935a23.318 23.318 0 0 1 3.68.002ZM11.25 4.573c-.691.18-.847.297-3.422 2.549-2.51 2.196-2.578 2.266-2.578 2.64 0 .691.726.997 1.294.545l.183-.144.023 2.336c.027 2.697.028 2.701.603 3.314.649.692.61.686 4.647.686s3.998.006 4.647-.686c.575-.613.576-.617.603-3.314l.023-2.336.183.144c.703.56 1.632-.147 1.212-.922-.16-.296-4.858-4.349-5.285-4.56-.659-.324-1.484-.422-2.133-.252Zm1.34 1.589c.163.073.696.506 1.699 1.383l1.461 1.277v2.702c0 3.494.006 3.474-1.137 3.475h-.363v-1.337c0-1.222-.008-1.362-.095-1.621-.696-2.066-3.614-2.066-4.31 0-.087.259-.095.4-.095 1.62V15h-.363c-1.143-.001-1.136.02-1.137-3.475V8.824l1.43-1.252c1.901-1.663 2.112-1.765 2.91-1.41Zm-.262 5.956c.371.186.418.379.42 1.744L12.75 15h-1.5v-1.113c0-.637.022-1.19.05-1.292.129-.464.609-.687 1.028-.476Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Verified-Home_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgVerifiedHome;
